import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const activity = {
  polymerizeSaleClass: data =>
    mallEntranceApi.post(apiPath.polymerizeSaleClass, data),
  polymerizeProduct: data =>
    mallEntranceApi.post(apiPath.polymerizeProduct, data),
  getActivityInfo: data => mallEntranceApi.post(apiPath.getActivityInfo, data)
}
